// Import project images
import bischoff1 from '../assets/projects/bischoff1.jpg';
import bischoff2 from '../assets/projects/bischoff2.jpg';
import lescale1 from '../assets/projects/lescalebeaute1.png';
import lescale2 from '../assets/projects/lescalebeaute2.png';
import oxane from '../assets/projects/oxane.JPG';
import lisaRgb1 from '../assets/projects/LisaRgb1.png';
import lisaRgb2 from '../assets/projects/LisaRgb2.png';

export const projects = [
  {
    id: 1,
    title: 'Optique Bischoff',
    coverImage: bischoff1,
    image: bischoff2,
    context: 'Identité visuelle • Opticien',
    role: 'Direction artistique',
    year: '2024',
    description: 'Ce projet a été réalisé pour un opticien souhaitant une identité visuelle moderne, épurée et facile à reconnaître. J\'ai conçu un logo basé sur les initiales O et B de Optique Bischoff, dont l\'assemblage forme subtilement une paire de lunettes. Cette construction graphique permet d\'évoquer immédiatement l\'univers de l\'optique tout en conservant une esthétique sobre et contemporaine, renforcée par une palette de couleurs neutres.\n\nL\'identité a ensuite été déclinée sur l\'ensemble des supports de la boutique : cartes de visite, pochettes, produits lunettes, enseigne lumineuse, habillage… assurant une image cohérente et professionnelle à chaque point de contact.',
    colors: ['#c3b49a', '#1d1d1b']
  },
  {
    id: 2,
    title: "L'Escale Beauté",
    coverImage: lescale1,
    image: lescale2,
    context: 'Identité visuelle • Institut de beauté',
    role: 'Direction artistique',
    year: '2022',
    description: 'Inspiré par l\'atmosphère calme et chaleureuse de l\'institut L\'Escale Beauté, j\'ai développé une identité visuelle qui traduit cette parenthèse de bien-être que Léa souhaite offrir à ses clientes. L\'institut mise sur la douceur, le naturel et l\'authenticité à travers ses soins : massages, épilations, onglerie et rituels détente. J\'ai donc imaginé un univers graphique aux teintes végétales et apaisantes, associé à un monogramme élégant où une feuille vient se fondre dans les lettres « E » et « B ».',
    colors: ['#e8decf', '#7b7f60', '#414042']
  },
  {
    id: 3,
    title: 'Lisa Ringenbach',
    coverImage: lisaRgb1,
    image: lisaRgb2,
    context: 'Identité visuelle • Diététicienne',
    role: 'Direction artistique',
    year: '2020',
    description: 'Pour ce projet destiné à une diététicienne-nutritionniste, l\'objectif était de créer une identité visuelle à son image : professionnelle, douce et accessible. Proposant des consultations au cabinet ou par téléphone, elle souhaitait que son nom soit au cœur de son identité.\n\nJ\'ai donc imaginé un logo épuré, construit autour de son nom de famille et légèrement encerclé afin d\'évoquer l\'accompagnement, la bienveillance et le suivi personnalisé qu\'elle offre à ses patients.',
    colors: ['#7a625e', '#414042', '#e8decf']
  },
  {
    id: 4,
    title: 'Oxane',
    image: oxane,
    coverImage: oxane,
    context: 'Illustrations',
    role: 'Direction artistique',
    year: '2024',
    description: 'Série d\'illustrations personnelles. Exploration créative à travers différentes techniques et styles graphiques.',
    colors: ['#D4AF37', '#5C3A21', '#F0C8C8']
  }
];

